import { graphql, useStaticQuery } from 'gatsby';

export function getDSFooterCFQueryData() {
  return useStaticQuery(
    graphql`
      query {
        data: contentfulGlobalDsFooter(contentful_id: { eq: "5pJqtkKJnFtOGy4rn0x5KS" }) {
          id
          contactMenuItems {
            id
            title
            url
          }
          aboutUsMenuLabel
          aboutUsMenuItems {
            id
            title
            url
          }
          productMenuLabel
          productMenuItems {
            id
            title
            url
          }
          treatmentMenuLabel
          treatmentMenuItems {
            id
            title
            url
          }
          socialMenuLabel
          socialMenuItems {
            id
            url
            urlSuffix
            type {
              name: type
            }
            socialIcon {
              title
              file {
                url
              }
              gatsbyImageData(width: 24, height: 24, layout: FIXED, quality: 100, formats: [AVIF, WEBP, AUTO])
            }
          }
          influencerLink {
            id
            title
            url
          }
          feedbackInfo {
            url
            score
            maxScore
            title
            urlLabel: url_label
            reviewsCount: reviews_count
          }
          feedbackLogo {
            title
            gatsbyImageData(width: 50, height: 50, layout: FIXED, formats: [AVIF, WEBP, AUTO])
          }
          feedbackStars {
            title
            gatsbyImageData(width: 73, layout: CONSTRAINED, formats: [AVIF, WEBP, AUTO])
          }
          locationsHeader
          locations {
            id
            title
            url
          }
          locationsMoreLink {
            id
            title
            url
          }
          copyrightsMenuLabel
          copyrightsMenuItems {
            id
            title
            url
          }
        }
      }
    `,
  );
}
